module.exports = __webpack_public_path__ + "img/4.472c810f.jpg";